import { getParent, getRoot, Instance, types } from 'mobx-state-tree';
import { INewsStore } from '../news';
import { IRootStore } from 'store/root';
import MapleMStore from './maple-m';
import MapleWorldStore from './maple-world';

export const ToyCommuStore = types
    .model('ToyCommuStore', {
        mapleM: types.optional(MapleMStore, {}),
        mapleWorld: types.optional(MapleWorldStore, {})
    })
    .views((self) => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
        get productId(): string {
            return getParent<INewsStore>(self).productId;
        },
        get locale(): string {
            return getParent<INewsStore>(self).locale;
        },
        get category(): string {
            return getParent<INewsStore>(self).Category;
        },
        get categories(): string[] {
            return getParent<INewsStore>(self).Categories;
        },
        get isMapleM(): boolean {
            return ['59789'].includes(this.productId);
        },
        get isMapleWorld(): boolean {
            return ['59794'].includes(this.productId);
        },
        get currentIndex(): number | undefined {
            return getParent<INewsStore>(self).currentIndex;
        }
    }))
    .views((self) => ({
        get list() {
            if (self.isMapleM) {
                return self.mapleM.list;
            }

            return self.mapleWorld.list;
        },
        get filtered() {
            if (self.isMapleM) {
                return self.mapleM.filtered;
            }
            return self.mapleWorld.filtered;
        },
        get currentNews() {
            if (self.isMapleM) {
                return self.mapleM.currentNews;
            }
            return self.mapleWorld.currentNews;
        },
        get prev() {
            if (self.isMapleM) {
                return self.mapleM.prev;
            }

            return self.mapleWorld.prev;
        },
        get next() {
            if (self.isMapleM) {
                return self.mapleM.next;
            }

            return self.mapleWorld.next;
        }
    }))
    .actions((self) => ({
        setCategory(cat: string) {
            getParent<INewsStore>(self).setCategory(cat);
        },
        getCategories() {
            if (self.isMapleM) {
                return self.mapleM.getCategories();
            }

            return self.mapleWorld.getCategories();
        },
        fetchList() {
            if (self.isMapleM) {
                return self.mapleM.fetchList();
            }
            return self.mapleWorld.fetchList();
        },
        isDefaultThumbnail(url: string): boolean {
            return getParent<INewsStore>(self).isDefaultThumbnail(url);
        },
        setCurrent(newsId: number | undefined) {
            if (self.isMapleM) {
                return self.mapleM.setCurrent(newsId);
            }

            return self.mapleWorld.setCurrent(newsId);

        },
        setCurrentIndex(idx: number | undefined) {
            getParent<INewsStore>(self).setCurrentIndex(idx);
        }
    }))

export interface IToyCommuStore extends Instance<typeof ToyCommuStore> {}